module.exports = "<div class=\"loans-detail-collapse\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n  <div class=\"loans-detail-collapse-header\" ng-click=\"$ctrl.toggleMoreInfo()\">\n    <h2 class=\"title\">{{ $ctrl.title | translate }}</h2>\n    <i class=\"icon icon-arrow-select-down\" ng-class=\"{ 'show-info-rotation': $ctrl.moreInfoIsVisible === true }\">\n    </i>\n    <p>{{ $ctrl.subtitle | translate }}</p>\n  </div>\n  <div ng-show=\"$ctrl.moreInfoIsVisible\">\n    <ng-transclude></ng-transclude>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansDetail/loansDetailCollapse/loansDetailCollapse.html
// module id = 1832
// module chunks = 0